import QRCode from 'qrcode'

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

const LABEL_WIDTH = 1441
const LABEL_HEIGHT = 2161

export default async (opts, first_batch_ship_box) => {
    //Information box
    const {
        barcodeNumber, labelDetails, name, address1, address2, city, country, state, postalCode
    } = opts
    const {weight, height, length, width} = first_batch_ship_box
    const { shipping_carrier } = { ...labelDetails }
    const boxNumber = `#${barcodeNumber}`
    const weightText = `Weight: ${weight} kg`
    const heightText = `H: ${height} cm`
    const lengthText = `L: ${length} cm`
    const widthText = `W: ${width} cm`
    const addressCity = [city, `${state} ${postalCode}`].filter(i => !!i).join(', ')
    const address = [name, address1, address2, addressCity, country].filter(i => !!i)

    //QR image
    const qrDataUrl = await QRCode.toDataURL(boxNumber, { width: 200, margin: 3 })
    const qrDataImage = await _makeImage(qrDataUrl)

    //Created canvas
    const canvas = document.createElement('canvas')
    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT
    const ctx = canvas.getContext('2d')

    //Init canvas page
    ctx.beginPath()
    ctx.fillStyle = 'white'
    ctx.fill()

    //Draw rect
    ctx.lineWidth = 4
    ctx.rect(10, 45, LABEL_WIDTH - 50, LABEL_HEIGHT - 50)
    ctx.stroke()

    //Draw label number
    ctx.fillStyle = 'black'
    ctx.font = 'bold 90px Arial'
    ctx.fillText(boxNumber, 100, 200)

    //Draw weight
    ctx.fillStyle = 'black'
    ctx.font = '70px Arial'
    ctx.fillText(weightText, 100, 300)

    //Draw height
    ctx.fillStyle = 'black'
    ctx.font = '70px Arial'
    ctx.fillText(heightText, 100, 400)

    //Draw length
    ctx.fillStyle = 'black'
    ctx.font = '70px Arial'
    ctx.fillText(lengthText, 100, 500)

    //Draw width
    ctx.fillStyle = 'black'
    ctx.font = '70px Arial'
    ctx.fillText(widthText, 100, 600)

    //Draw address
    if (address.length > 0) {
        address.forEach((i, index) => {
            if (!!i) {
                ctx.fillStyle = 'black'
                ctx.font = '70px Arial'
                ctx.fillText(i, 100, (1000 + (index * 80)))
            }
        });
    }

    //Draw QR image
    // ctx.drawImage(qrDataImage, (LABEL_WIDTH-135), 50, 135, 135)
    const qrSize = 670
    const qrLeft = LABEL_WIDTH - qrSize - (50)
    ctx.drawImage(qrDataImage, qrLeft, 50, qrSize, qrSize)

    //Draw shipping carrier
    ctx.fillStyle = 'black'
    ctx.font = 'bold 130px Arial'
    ctx.textAlign = "center"
    ctx.fillText(shipping_carrier, LABEL_WIDTH / 2, LABEL_HEIGHT - 100)

    return canvas.toDataURL()
}
